/**
 * Every Gateway path this module calls.
 *
 * The three reference paths point at reference-service, not auth-service:
 * geography is platform-wide data that one service owns, and the duplicate
 * read paths under `/v1/tenants/countries` are the last of the three the
 * blueprint retires.
 *
 * The tenant write path still takes surrogate ids, and the options endpoint
 * answers codes, so the queries map `meta.id` back into the `{ id, code, name }`
 * shape the form already holds.
 */
export const tenantEndpoints = {
  list: '/v1/tenants/crud',
  create: '/v1/tenants/crud',
  detail: (tenantId: string) => `/v1/tenants/crud/${tenantId}`,
  update: (tenantId: string) => `/v1/tenants/crud/${tenantId}`,
  delete: (tenantId: string) => `/v1/tenants/crud/${tenantId}`,
  countries: '/v1/countries/options?limit=50',
  states: (countryCode: string) =>
    `/v1/states/options?countryCode=${encodeURIComponent(countryCode)}&limit=50`,
  cities: (countryCode: string, stateCode: string) =>
    `/v1/cities/options?countryCode=${encodeURIComponent(countryCode)}&stateCode=${encodeURIComponent(stateCode)}&limit=50`,
  modules: '/v1/tenants/modules',
  assignModules: (tenantId: string) => `/v1/tenants/crud/${tenantId}/modules`,
  adminStatus: (tenantId: string, userId: string) =>
    `/v1/tenants/${tenantId}/admins/${userId}/status`,
  attachmentCredentials: (tenantId: string) => `/v1/attachments/credentials/${tenantId}`,
} as const;
